var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bean-source-page',{attrs:{"type":"index","columns":_vm.tableColumns,"filter-columns":_vm.filterColumns,"actions":[],"action-buttons":[],"title":_vm.$t('menu.achievementPayCompute'),"onFetchData":_vm.onFetchData,"enableTableToExcel":""}})}
var staticRenderFns = []

export { render, staticRenderFns }